/* Montigenix RaceChip browser 2026-09-24-rc1. Collection-only, explicit-fitment matching. */
(function () {
  'use strict';
  const VERSION = '2026-09-24-rc1';
  if (window.MontigenixRaceChip && window.MontigenixRaceChip.version === VERSION) {
    window.MontigenixRaceChip.init();
    return;
  }
  const clean = value => String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  const key = value => clean(value).normalize('NFKC').toLowerCase();
  const sorted = map => [...map.entries()].sort((a, b) => a[1].label.localeCompare(b[1].label, 'en', {numeric: true}));
  const makeAliases = new Map([['vw', 'Volkswagen'], ['volkswagen', 'Volkswagen'], ['bmw', 'BMW'], ['mini', 'MINI'], ['mercedes', 'Mercedes-Benz'], ['mercedes benz', 'Mercedes-Benz'], ['mercedes-benz', 'Mercedes-Benz']]);

  function parseFitment(product) {
    if (!product || key(product.vendor) !== 'racechip') return null;
    const text = clean(product.description);
    const start = text.search(/specifications\s+and\s+fitment\b/i);
    if (start < 0) return null;
    const section = text.slice(start).split(/availability\s+and\s+delivery\b/i)[0];
    const pattern = /\b(Make|Model|Engine|Stock kW|RaceChip kW|Stock Nm|RaceChip Nm|Vehicle Id|GTIN)\s*:/gi;
    const labels = [...section.matchAll(pattern)], fields = new Map();
    for (let i = 0; i < labels.length; i++) {
      const name = key(labels[i][1]);
      const value = clean(section.slice(labels[i].index + labels[i][0].length, i + 1 < labels.length ? labels[i + 1].index : section.length));
      if (fields.has(name) && key(fields.get(name)) !== key(value)) return null;
      fields.set(name, value);
    }
    const make = fields.get('make'), model = fields.get('model'), engine = fields.get('engine');
    if (![make, model, engine].every(value => value && value.length <= 200 && !/^(?:n\/?a|none|null|undefined|universal|all)$/i.test(value))) return null;
    const power = engine.match(/\b(\d+(?:[.,]\d+)?)\s*kw\b/i);
    const stock = (fields.get('stock kw') || '').match(/^(\d+(?:[.,]\d+)?)\s*kw$/i);
    if (power && stock && Number(power[1].replace(',', '.')) !== Number(stock[1].replace(',', '.'))) return null;
    return {make: makeAliases.get(key(make)) || make, model, engine: !power && stock ? engine + ' ' + fields.get('stock kw') : engine};
  }

  function buildIndex(products) {
    const makes = new Map(), fitments = new Map(), seen = new Set();
    for (const product of products) {
      if (!product || !product.id || seen.has(String(product.id))) continue;
      seen.add(String(product.id));
      if (product.status && key(product.status) !== 'active') continue;
      const fitment = parseFitment(product);
      if (!fitment) continue;
      fitments.set(String(product.id), fitment);
      const mk = key(fitment.make), mo = key(fitment.model), en = key(fitment.engine);
      if (!makes.has(mk)) makes.set(mk, {label: fitment.make, models: new Map(), ids: new Set()});
      const make = makes.get(mk); make.ids.add(String(product.id));
      if (!make.models.has(mo)) make.models.set(mo, {label: fitment.model, engines: new Map(), ids: new Set()});
      const model = make.models.get(mo); model.ids.add(String(product.id));
      if (!model.engines.has(en)) model.engines.set(en, {label: fitment.engine, products: []});
      model.engines.get(en).products.push(product);
    }
    return {makes, fitments};
  }

  function init() {
    const root = document.getElementById('mg-racechip-browser');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true'; root.dataset.version = VERSION;
    const form = root.querySelector('form'), makeSelect = form.elements.make, modelSelect = form.elements.vehicle, engineSelect = form.elements.engine;
    const submit = form.querySelector('[type=submit]'), clearButton = root.querySelector('[data-rc-clear]'), retry = root.querySelector('[data-rc-retry]');
    const status = root.querySelector('[data-rc-status]'), results = root.querySelector('[data-rc-results]'), grid = root.querySelector('.mg-grid'), more = root.querySelector('[data-rc-more]'), heading = root.querySelector('[data-rc-heading]');
    const main = document.querySelector('main'), moved = [];
    const native = main ? [...main.querySelectorAll(':scope > .cc-collection-products, :scope > .cc-collection-banner, :scope > .cc-collection-list')] : [];
    if (native.length) native[0].before(root);
    let products = [], matches = [], index = {makes: new Map(), fitments: new Map()}, shown = 0, loading = false;
    const option = (value, label, count) => {
      const result = document.createElement('option'); result.value = value; result.textContent = label;
      if (count != null) result.dataset.matchCount = String(count);
      return result;
    };
    const reset = (select, label) => { select.replaceChildren(option('', label)); select.disabled = true; };
    const currentMake = () => index.makes.get(makeSelect.value);
    const currentModel = () => currentMake() && currentMake().models.get(modelSelect.value);
    const currentEngine = () => currentModel() && currentModel().engines.get(engineSelect.value);
    const disableFilters = () => { reset(makeSelect, 'Choose make'); reset(modelSelect, 'Choose model'); reset(engineSelect, 'Choose engine'); submit.disabled = true; };
    function showNative() {
      moved.splice(0).forEach(element => { element.hidden = false; });
      results.hidden = true;
    }
    function modelChoices() {
      reset(modelSelect, 'Choose model'); reset(engineSelect, 'Choose engine'); submit.disabled = true;
      const selected = currentMake(); if (!selected) { showAll(); return; }
      sorted(selected.models).forEach(([id, model]) => modelSelect.append(option(id, model.label, model.ids.size)));
      modelSelect.disabled = modelSelect.options.length < 2;
      if (!results.hidden) { matches = []; grid.replaceChildren(); more.hidden = true; heading.textContent = 'Choose a model'; }
      status.textContent = 'Choose a model for ' + selected.label + ', then its engine and original power output.';
    }
    function engineChoices() {
      reset(engineSelect, 'Choose engine'); submit.disabled = true;
      const selected = currentModel();
      if (!selected) { matches = []; grid.replaceChildren(); more.hidden = true; heading.textContent = 'Choose a model'; status.textContent = 'Choose a model, then its engine.'; return; }
      sorted(selected.engines).forEach(([id, engine]) => engineSelect.append(option(id, engine.label, engine.products.length)));
      engineSelect.disabled = engineSelect.options.length < 2;
      if (!results.hidden) { matches = []; grid.replaceChildren(); more.hidden = true; heading.textContent = 'Choose an engine'; }
      status.textContent = 'Choose the engine and original kW for ' + selected.label + '.';
    }
    makeSelect.addEventListener('change', modelChoices);
    modelSelect.addEventListener('change', engineChoices);
    engineSelect.addEventListener('change', () => {
      submit.disabled = !currentEngine();
      matches = []; grid.replaceChildren(); more.hidden = true;
      heading.textContent = 'Select Find products';
      status.textContent = currentEngine() ? 'Select Find products to display this engine\'s RaceChip listings.' : 'Choose an engine.';
    });
    function addCards() {
      matches.slice(shown, shown + 24).forEach(product => {
        const wrapper = document.createElement('div'); wrapper.className = 'mg-product'; wrapper.dataset.productId = String(product.id);
        const card = document.createElement('a'); card.className = 'mg-card';
        const url = new URL(product.url || '/products/' + encodeURIComponent(product.handle), window.location.origin);
        if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) return;
        card.href = url.pathname + url.search;
        if (product.image && /^(?:https:\/\/|\/\/)/i.test(product.image)) {
          const image = document.createElement('img'); image.src = product.image; image.alt = product.title; image.loading = 'lazy'; image.width = 400; image.height = 400; card.append(image);
        } else {
          const missing = document.createElement('div'); missing.className = 'mg-image-pending'; missing.textContent = 'Image pending'; card.append(missing);
        }
        const title = document.createElement('h3'); title.textContent = product.title; card.append(title);
        const price = document.createElement('p'); price.className = 'mg-price'; price.textContent = product.price_text || ''; card.append(price);
        const note = document.createElement('p'); note.className = 'mg-fitment-note';
        const fitment = index.fitments.get(String(product.id));
        note.textContent = fitment ? fitment.make + ' · ' + fitment.model + ' · ' + fitment.engine : 'Vehicle-specific fitment is not listed. Please contact us before ordering.';
        card.append(note);
        const details = document.createElement('p'); details.textContent = 'View details'; card.append(details); wrapper.append(card); grid.append(wrapper);
      });
      shown += 24; more.hidden = shown >= matches.length;
    }
    function render(label) {
      native.forEach(element => { if (!element.hidden) { moved.push(element); element.hidden = true; } });
      results.hidden = false; grid.replaceChildren(); shown = 0; heading.textContent = label; addCards();
    }
    function showAll() {
      makeSelect.value = ''; reset(modelSelect, 'Choose model'); reset(engineSelect, 'Choose engine'); submit.disabled = true;
      matches = products; render('All RaceChip products');
      const unassigned = products.length - index.fitments.size;
      status.textContent = products.length + ' RaceChip collection products. Choose make, model and engine to filter.' + (unassigned ? ' ' + unassigned + ' listings without complete fitment details remain under Show all.' : '');
    }
    clearButton.addEventListener('click', showAll); more.addEventListener('click', addCards);
    form.addEventListener('submit', event => {
      event.preventDefault(); const engine = currentEngine(); if (!engine || loading) return;
      matches = engine.products;
      const label = currentMake().label + ' · ' + currentModel().label + ' · ' + engine.label;
      render(label);
      status.textContent = matches.length + (matches.length === 1 ? ' matching listing. ' : ' matching listings. ') + 'Confirm vehicle year and engine specification before ordering.';
    });

    async function loadPage(page) {
      const url = new URL(root.dataset.collectionUrl, window.location.origin);
      if (url.origin !== window.location.origin) throw new Error('Invalid collection URL');
      url.search = ''; url.searchParams.set('view', 'mg-racechip-feed'); url.searchParams.set('page', String(page)); url.searchParams.set('sort_by', 'title-ascending');
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const abort = new AbortController(), timer = setTimeout(() => abort.abort(), 20000);
      try {
        const response = await fetch(url.href, {credentials: 'same-origin', signal: abort.signal});
        if (!response.ok) throw new Error('RaceChip feed HTTP ' + response.status);
        const data = await response.json();
        if (data.version !== VERSION || data.handle !== 'racechip' || String(data.collection_id) !== root.dataset.collectionId || data.page !== page || !Number.isInteger(data.pages) || data.pages < 0 || data.pages > 100 || !Number.isInteger(data.total) || data.total < 0 || data.total > 25000 || !Array.isArray(data.products) || data.products.length > 250) throw new Error('Invalid RaceChip feed');
        return data;
      } finally { clearTimeout(timer); }
    }
    async function start() {
      if (loading) return;
      loading = true; disableFilters(); clearButton.disabled = true; retry.hidden = true; showNative(); root.setAttribute('aria-busy', 'true'); delete root.rcVehicleAudit;
      status.textContent = 'Loading all RaceChip products before building vehicle choices…';
      try {
        const first = await loadPage(1), pages = [first];
        let next = 2;
        await Promise.all(Array.from({length: Math.min(3, Math.max(0, first.pages - 1))}, async () => {
          while (next <= first.pages) {
            const page = next++, data = await loadPage(page);
            if (data.pages !== first.pages || data.total !== first.total) throw new Error('RaceChip collection changed while loading');
            pages[page - 1] = data;
          }
        }));
        const all = pages.flatMap(page => page.products), ids = new Set();
        for (const product of all) {
          if (!product || !/^\d+$/.test(String(product.id)) || ids.has(String(product.id)) || !product.handle || !product.title || !product.url || typeof product.description !== 'string') throw new Error('Invalid or repeated RaceChip record');
          ids.add(String(product.id));
        }
        if (all.length !== first.total) throw new Error('Incomplete RaceChip collection');
        products = all; index = buildIndex(products);
        reset(makeSelect, 'Choose make');
        sorted(index.makes).forEach(([id, make]) => makeSelect.append(option(id, make.label, make.ids.size)));
        makeSelect.disabled = makeSelect.options.length < 2;
        root.rcVehicleAudit = {version: VERSION, collectionId: root.dataset.collectionId, total: products.length, indexed: index.fitments.size, makes: sorted(index.makes).map(([, make]) => ({make: make.label, models: sorted(make.models).map(([, model]) => ({model: model.label, engines: sorted(model.engines).map(([, engine]) => ({engine: engine.label, productIds: engine.products.map(product => String(product.id))}))}))}))};
        clearButton.disabled = false; showAll();
        if (!index.makes.size) status.textContent = products.length ? 'RaceChip products are shown below. No complete vehicle fitment details are currently listed; please contact us to confirm compatibility.' : 'There are currently no published products in this RaceChip collection.';
      } catch (error) {
        disableFilters(); showNative(); retry.hidden = false;
        status.textContent = 'RaceChip products could not be verified. The standard collection remains available below. Please retry loading.';
        console.warn('Montigenix RaceChip filter:', error.message);
      } finally { loading = false; root.setAttribute('aria-busy', 'false'); }
    }
    retry.addEventListener('click', start); start();
  }
  window.MontigenixRaceChip = {version: VERSION, parseFitment, buildIndex, init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
